import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "device-unlock",
  "use": "device-unlock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"device-unlock\"><path d=\"M8.5 14v2h3v-2h-3z\" /><path d=\"M15.8 5A2.8 2.8 0 0 0 13 7.8V10H3.2A1.2 1.2 0 0 0 2 11.2v7.6A1.2 1.2 0 0 0 3.2 20h13.6a1.2 1.2 0 0 0 1.2-1.2v-7.6a1.2 1.2 0 0 0-1.2-1.2H15V7.8a.8.8 0 0 1 .8-.8h4.4a.8.8 0 0 1 .8.8V9h2V7.8A2.8 2.8 0 0 0 20.2 5h-4.4zM4 12h12v6H4v-6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol